export class Global {
  static readonly AUTH_KEY = 'ls.auth';
  static readonly LANG_KEY = 'languge';
  static readonly TABLE_SORTS_KEY = 'tableSorts';
  static readonly REPORT_LANG = 'reportLanguage';
  static readonly SCANNER_CAMERA_KEY = 'scannerCamera';
  static readonly LOGGER_CODE_HEADER = 'X-Verification-Code';
  static readonly LOGGER_SUBMISSION_HEADER = 'X-Submission-Token';
}

export class Entity {
  static readonly Statuses = {
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
    DELETED: 'Deleted',
  };
}